import { useIntl } from 'react-intl';

import { Box } from '../../../common/box';
import { IResetPasswordProps } from './reset-password.models';
import { Stepper } from '../../../common/stepper';
import { resetPasswordSteps } from './reset-password.steps';
import { Page } from '../page/page';
import { CaptchaType } from '../../../../graphql/configuration';

export const ResetPassword = ({ onDone, externalState }: IResetPasswordProps): JSX.Element => {
  const intl = useIntl();

  return (
    <Page
      title={intl.formatMessage({ id: 'resetPasswordPage.title' })}
      description={intl.formatMessage({ id: 'resetPasswordPage.description' })}
      pageScript={externalState?.captcha?.type === CaptchaType.reCaptcha ? process.env.REACT_APP_RECAPTCHA_API_URL : undefined}
    >
      <Box>
        <Stepper
          disableStepIndicators
          steps={resetPasswordSteps}
          onDone={onDone}
          externalState={externalState}
        />
      </Box>
    </Page>
  );
};
